<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-manager`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 3c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10S19.477 3 25 3zm0 20h5c5.523 0 12 4.286 12 12v6a2 2 0 01-2 2H8a2 2 0 01-2-2v-6c0-7.708 6.477-12 12-12h7zm-6.429 4H18c-3.66 0-8 2.812-8 8v4h28v-4c0-4.864-3.96-7.787-7.599-7.989L31 33l-6.5 5-6.5-5 .571-6zm4.018 0h3.791l.419 4.185-2.299 1.768-2.308-1.775.397-4.178zM19 13a6 6 0 1112 0 6 6 0 01-12 0z"/></svg>
</template>
<script>

export default {
  name: 'IconManager',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
